/* eslint-disable react/prop-types */
import * as React from 'react';

import { Radio } from 'antd';

import { cn } from 'utils';

const PrimitiveRadioGroup = React.forwardRef<
  React.ElementRef<typeof Radio.Group>,
  React.ComponentPropsWithoutRef<typeof Radio.Group>
>(
  (
    {
      block = true,
      size = 'large',
      buttonStyle = 'solid',
      className,
      ...props
    },
    ref,
  ) => (
    <Radio.Group
      ref={ref}
      block={block}
      size={size}
      buttonStyle={buttonStyle}
      className={cn('*:text-[12px] *:font-medium', className)}
      {...props}
    />
  ),
);
PrimitiveRadioGroup.displayName = 'PrimitiveRadioGroup';

const PrimitiveRadioButton = React.forwardRef<
  React.ElementRef<typeof Radio.Button>,
  React.ComponentPropsWithoutRef<typeof Radio.Button>
>((props, ref) => <Radio.Button ref={ref} {...props} />);
PrimitiveRadioButton.displayName = 'PrimitiveRadioButton';

export { PrimitiveRadioButton, PrimitiveRadioGroup };
